
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import type { PackageData } from "@/pages/CreatePackage";

type HotelStay = PackageData['hotels'][0];

interface PackageHotelsListProps {
  packageHotels: HotelStay[];
  onRemoveHotel: (index: number) => void;
}

export const PackageHotelsList = ({ packageHotels, onRemoveHotel }: PackageHotelsListProps) => {
  if (packageHotels.length === 0) {
    return null;
  }

  const total = packageHotels.reduce((acc, h) => acc + (h.pricePerNight * h.nights), 0);

  return (
    <div className="space-y-4 rounded-lg border p-4">
      <h3 className="font-medium text-lg mb-2">الفنادق المضافة للعرض</h3>
      {packageHotels.map((hotel, index) => (
        <div key={index} className="flex justify-between items-center bg-gray-50 p-3 rounded-md">
          <div>
            <p className="font-bold">{hotel.name} - {hotel.roomType}</p>
            <p className="text-sm text-gray-600">{hotel.location} | {hotel.nights} ليالي</p>
            <p className="text-sm text-gray-600">من: {hotel.checkIn} إلى: {hotel.checkOut}</p>
          </div>
          <div className="flex items-center gap-4">
            <p className="font-semibold text-blue-600">{(hotel.pricePerNight * hotel.nights).toLocaleString()} SAR</p>
            <Button variant="ghost" size="icon" onClick={() => onRemoveHotel(index)}>
              <Trash2 className="w-4 h-4 text-red-500" />
            </Button>
          </div>
        </div>
      ))}
      <div className="pt-2 mt-2 border-t text-right">
        <p className="font-bold text-xl">
          الإجمالي: {total.toLocaleString()} SAR
        </p>
      </div>
    </div>
  );
};
